<script>
    import { onMount } from "svelte";
    import Confirmation from "./Modal/Confirmation.svelte";
    import Pagination from "./Pagination.svelte";
    import UserProjectsApi from "../api/user_projects";
    import UserApi from "../api/user";
    import Util from "../util";
    import Tooltip from "./Tooltip.svelte";
    import AutoSavingLoading from "./AutoSavingLoading.svelte";
    //
    let projects = [],
        projectsPag = [],
        currentPag = 0,
        totalPag = 0,
        totalItems = 0,
        itemsPerPag = 10,
        itemPagFm = 0,
        itemPagTo = 0;
    let showConfirmation = false;
    let item = {};
    let userProfile = {};
    let saving = false;
    const savingTimeout = 1000;

    $: if (currentPag > 0) {
        totalItems = projects.length;
        totalPag = Math.ceil(totalItems / itemsPerPag);
        itemPagFm = currentPag * itemsPerPag - itemsPerPag;
        itemPagTo = currentPag * itemsPerPag;
        projectsPag = projects.slice(itemPagFm, itemPagTo);
    }

    const loadProjects = async () => {
        try {
            projects = await UserProjectsApi.getAsync();
            currentPag = 1;
        } catch (error) {
            console.error(error);
        }
    };
    const createUserProject = async () => {
        try {
            const data = await UserProjectsApi.postAsync();
            window.location.href = `#/project/edit/${data.ID}`;
        } catch (error) {
            console.error(error);
        }
    };
    const deleteUserProject = async () => {
        try {
            saving = true;
            Util.showProgress();
            showConfirmation = false;
            if (!item.ID) return;
            await UserProjectsApi.deleteAsync({ id: item.ID });
            await loadProjects();
        } catch (error) {
            console.error(error);
        } finally {
            Util.hideProgress();
            setTimeout(() => saving = false, savingTimeout);
        }
    };
    const loadUserProfile = async () => {
        try {
            userProfile = await UserApi.getAsync();
        } catch (error) {
            console.error(error);
        }
    };
    onMount(async () => {
        await loadProjects();
        await loadUserProfile();
        Util.popoverInit();
    });
    const onRetrieveData = () => {
        ColorCalcRetrieveData.show();
    };
    const onSaveEmail = () => {
        ColorCalcAnonymousData.show();
    };
</script>

<Tooltip style="top: 20px; left: 0px; display: none;" position="top" number="1" title="" text="List of your current product configurations that are sent from the ‘Construct IGUs’ page.  IGDB color values (L*, a*, b*) for the configurations are sent as well.  One or all the product configurations can then be selected to be assigned to individual Projects.  Custom Product Configurations can also be entered without using the Construct IGUs page" />
<Tooltip style="top: 230px; left: 150px; display: none;" position="bottom" number="2" title="" text="Here are listed your various saved Projects and associated Product Configurations and Color Data.  If you have not created a Project yet, use the ‘+Create New Project’ button, and you will be able to name the project and select product configurations to add to it." />
<div class="mt-1">
    <AutoSavingLoading saving={saving} />
</div>
<div class="mt-1" style="display: flex;justify-content: flex-end;font-size: 10px;">
    <span>*All changes are autosaved</span>
</div>
<div class="row mb-3">
    <div class="col sm-6 ml-3">
        <div style="display: flex; align-items: center;">
            <a href="#/products" type="button" class="btn btn-gray active text-secondary"
                title="List of your current product configurations">
                Configuration/Products
            </a>
            <a href="#/projects" type="button" class="btn btn-orange text-white"
                title="List of your current projects">
                Projects
            </a>
            {#if !userProfile.Email}
                <a href="!" on:click|preventDefault={onRetrieveData} type="button"
                    class="btn btn-gray text-secondary optional-action"
                    title="Retrieve your previous data saved by input your email">
                    Retrieve Data
                </a>
                <a href="!" on:click|preventDefault={onSaveEmail} type="button"
                    class="btn btn-gray text-secondary optional-action"
                    title="Associate an email to your current progress and retrieve it later by using 'Retrieve Data'">
                    Save Progress
                </a>
            {/if}
            <div style="flex: 1; padding: 0px 10px; display: flex; justify-content: flex-end;">
                {#if !userProfile.Origin}
                    <span style="display: {userProfile.Origin ? 'none' : 'block'};">
                        Your email is: <strong>{userProfile.Email || ''}</strong>
                    </span>
                {:else}
                    {#if userProfile.Email}
                            <span>Saved email: <strong>{userProfile.Email}</strong></span>
                    {/if}
                {/if}
            </div>
            <div style="padding: 0px 10px; display: flex; justify-content: flex-end;">
                <button type="button" on:click={createUserProject} class="btn btn-outline-primary btn-sm"
                    title="Create an empty project and add any product configuration from the list available to you. To add products go to 'Configuration/Products' or to 'Construct IGUs'">
                    <span>+ Create New Project</span>
                </button>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12 ml-3">
        <table class="table table-bordered">
            <thead class="thead tbl-gray text-white">
                <tr>
                    <td>Project</td>
                    <td>Start Date</td>
                    <td>End Date</td>
                    <td>Status</td>
                    <td>Actions</td>
                </tr>
            </thead>
            <tbody>
                {#each projectsPag as project}
                    <tr>
                        <td>{project.Name}</td>
                        <td>
                            {Util.formatDate(project.StartDt)}
                        </td>
                        <td>
                            {Util.formatDate(project.EndDt)}
                        </td>
                        <td>
                            {#if project.Status == "ACTIVE"}
                                <i class="bi bi-circle-fill text-orange" />
                            {:else}
                                <i class="bi bi-circle-fill text-success" />
                            {/if}
                            {project.Status}
                        </td>
                        <td class="flex-center">
                            <i on:click={() => (window.location.href = `#/project/edit/${project.ID}`)}
                                title="Edit project"
                                class="btn-action pe-3 bi bi-pencil-square text-primary fs-5" />
                            <i on:click={() => {
                                    item = project;
                                    showConfirmation = true;
                                }}
                                title="Delete project"
                                class="btn-action pe-3 bi bi-trash text-danger fs-5"
                            />
                        </td>
                    </tr>
                {:else}
                    <p>You have 0 projects to display.</p>
                {/each}
            </tbody>
        </table>
        {#if totalItems > itemsPerPag}
            <Pagination bind:current_page={currentPag} last_page={totalPag} per_page={itemsPerPag} from={itemPagFm} to={itemPagTo} total={totalItems} />
        {/if}
    </div>
</div>
<Confirmation bind:isOpen={showConfirmation} btnOk="Delete" confirmFunction={deleteUserProject} message={`Are you sure you want to delete ${item.Name}?`} />

<style>
    a:hover {
        text-decoration: underline;
        color: #fff;
    }

    .btn-action:hover {
        cursor: pointer;
    }

    .btn-orange {
        background-color: #e67e22;
    }

    .btn-gray {
        background-color: #e5e7e9;
    }

    .flex-center {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .tbl-gray {
        background-color: #3d4952;
    }

    .optional-action {
        margin-left: 10px;
    }

    .text-orange {
        color: #e67e22;
    }
</style>
